import { createContext } from 'react'

/** Avoids threading a glow flag through shared date-picker layers; set at panel/dropdown boundaries. */
const AIGlowHighlightContext = createContext(false)

export default AIGlowHighlightContext
